import { LoginCallBack, useOCAuth } from '@opencampus/ocid-connect-js'
import { supabase } from '../../../services/supabaseClient'
import { generatePassword } from '../../../utils/helpers'
import LoadingOverlay from '../../../components/common/LoadingOverlay'
import { useNavigate } from 'react-router-dom'
import { getUser } from '../../../api/supabaseApi'

const LoginRedirect = () => {
  const navigate = useNavigate()
  const { authState, ocAuth } = useOCAuth()

  const CustomErrorComponent = () => (
    <div>Error Logging in: {authState.error.message}</div>
  )

  const CustomLoadingComponent = () => <LoadingOverlay />

  const loginError = (error) => {
    console.error('Login error:', error);
    navigate('/login')
  };

  const loginSuccess = async () => {
    const ocData = ocAuth.getAuthState()

    const { data: existingUser, error } = await supabase
      .from('users')
      .select('*')
      .eq('OCId', ocData.OCId)
      .single()

    const password = await generatePassword(ocData.OCId)
    const email = `${ocData.OCId}@privaterelay.mad-platform.com`

    if (!existingUser) {
      const { data: authUser, error: createUserError } =
        await supabase.auth.signUp({
          email: email,
          password: password,
          user_metadata: {
            OCId: ocData.OCId,
          },
        })

      if (!createUserError) {
        await supabase.from('users').upsert(
          [
            {
              id: authUser.user.id,
              full_name: ocData.OCId,
              email: email,
              OCId: ocData.OCId,
              provider: 'opencampus',
            },
          ],
          { onConflict: ['OCId'] }
        )
      }
    } else {
      await supabase.auth.signInWithPassword({
        email: email,
        password: password,
      })
    }

    // const {data: {user}} = await supabase.auth.getUser();
    //
    // const data = await getUser(user.id)
    //
    // const hasFullName = data?.full_name ? true : false

    // if (!hasFullName){
    //   navigate('/register')
    // } else if (!data?.avatars) {
    //   navigate('/create-avatar')
    // } else {
    //   navigate('/')
    // }

    navigate('/')
  }

  return (
    <LoginCallBack
      errorCallback={loginError}
      customErrorComponent={<CustomErrorComponent />}
      customLoadingComponent={<CustomLoadingComponent />}
      successCallback={loginSuccess}
    />
  )
}

export default LoginRedirect
